/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 *
 */

/**
 * Retorna o pedido
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * DATE: 26/03/2013
 */


Greenmile.Stop = Greenmile.Stop || {};

Greenmile.Stop.Return =  function ({
  parentSelector = '#RouteSummary',
  successCallback
} = {}) {

    Greenmile.Stop.Base.call(this);

    this.successCallbackAppendCollection = false;

    this.getLayout = function () {
        const date = new Monet.Date.GeneralFunctions();
        const util = Greenmile.Stop.Util;
        const drivers = util.getParametersToTemplate('Greenmile.Stop.Arrive.driversList', 'driversList');
        const dateTimeField = util.getParametersToTemplate('Greenmile.Stop.Return.dateTimeFieldLabel', 'returnTime',
            date.getCurrentDateAndTime());
        const returnCode = util.getParametersToTemplate('Greenmile.Stop.Return.returnCodesList', 'returnCodes');

        const layout = {
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "monetInlineAlerContainer"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "attributes": {
                                                "class": "popup-modal-header"
                                            },
                                            "items": [
                                                {
                                                    "tag": "h3",
                                                    "html": Monet.I18n.getResourcesByKey('Greenmile.Stop.Return.btnSave'),
                                                },
                                                {
                                                    "tag": "div",
                                                    "items": [
                                                        {
                                                            "tag": "a",
                                                            "attributes": {
                                                                "href": "https://greenmile.help.descartesservices.com",
                                                                "class": "MonetUIHelpLink",
                                                                "title": "Help"
                                                            },
                                                        }
                                                    ],
                                                    "attributes": {
                                                        "class": "MonetUIHelp"
                                                    },
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-body"
                                            },
                                            "items": [
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": dateTimeField.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": dateTimeField.name
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "text",
                                                        "id": dateTimeField.name,
                                                        "value": dateTimeField.value,
                                                        "name": dateTimeField.name,
                                                        "class": "dateTimePicker"
                                                    }
                                                },
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": returnCode.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": returnCode.name
                                                    }
                                                },
                                                {
                                                    "tag": "select",
                                                    "attributes": {
                                                        "name": returnCode.name,
                                                        "id": returnCode.name
                                                    }
                                                },
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": drivers.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": drivers.name
                                                    }
                                                },
                                                {
                                                    "tag": "select",
                                                    "attributes": {
                                                        "name": drivers.name,
                                                        "id": drivers.name
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-footer formButtons"
                                            },
                                            "items": [
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": Monet.I18n.getResourcesByKey('Greenmile.Stop.Return.btnSave'),
                                                        "name": "btn_save_return_stop",
                                                        "id": "btn_save_return_stop",
                                                        "class": "btn",
                                                        "style": "width: 170px"
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": Monet.I18n.getResourcesByKey('Greenmile.Stop.Return.btnExit'),
                                                        "name": "btn_exit_return_stop",
                                                        "id": "btn_exit_return_stop",
                                                        "class": "btn secondary",
                                                        "style": "width: 75px"
                                                    }
                                                }
                                            ],
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "id": "formReturnStopFormTemplate"
                    }
                }
            ]
        };
        return (new Monet.UI.LayoutGenerator(layout)).render();
    };

    this.createForm = function () {
        const date = new Monet.Date.GeneralFunctions();
        const modalContainer = document.querySelector(`${parentSelector} .popupFormContainer`);

        if (modalContainer) {

            modalContainer.appendChild(this.getLayout());
            date.setDateTimePicker(`${parentSelector} .popupFormContainer .dateTimePicker`);

        } else {
            new Monet.Exception.ReturnError(this, "No .popupFormContainer found.")
                .console();
        }


    };

    this.loadData = function () {
      const undeliverableCodes = new App.Collections.UndeliverableCodes();
      const that = this;

      undeliverableCodes.filterWithCriteria({
        filter: {
          criteriaChain:[
            {
              and:[
                {
                  attr: "enabled",
                  eq: true
                }
              ]
            }
          ]
        },
        criteria: '{"filters":["id", "description", "type"]}',
        success: function () {
          that.populateReturnList(undeliverableCodes);
          that.loadDriverData();
        }
      });
    };

    this.populateDriversList = function (drivers) {

        var undeliverableCodeElement = document.querySelector("#formReturnStopFormTemplate #driversList");
        var driverLabel = document.querySelector("label[for='driversList']");
        var error = null;

        if (typeof(drivers) !== "undefined") {

            if (drivers.length > 0) {

                driverLabel.style.display = 'block';

                undeliverableCodeElement.innerHTML = "";

                for (var i = 0, j = drivers.length; i < j; i++) {

                    var option = document.createElement("option");

                    option.value = drivers[i].driver.id;
                    option.text = drivers[i].driver.name;

                    undeliverableCodeElement.appendChild(option);

                }
            } else {
                driverLabel.style.display = 'none';
            }

        } else {

            error = new Monet.Exception.ReturnError(this,
                "No collection loaded");
            error.console();

        }

    };

    this.populateReturnList = function (collection) {

        var returnCodeElement = document.querySelector("#formReturnStopFormTemplate #returnCodes");
        var error = null;

        returnCodeElement.innerHTML = "";

        if (typeof(collection) !== "undefined") {

            for (var i = 0, j = collection.size(); i < j; i++) {

                var type = collection.at(i).get("type");

                if (type === "B" || type === "U") {

                    var option = document.createElement("option");

                    option.value = collection.at(i).get("id");
                    option.text = collection.at(i).get("description");

                    returnCodeElement.appendChild(option);
                }

            }
        } else {
            error = new Monet.Exception.ReturnError(this,
                "No collection loaded");
            error.console();
        }

    };

    this.addEventListenners = function () {

        try {

            var that = this;
            var btnSave = document.querySelector("#formReturnStopFormTemplate #btn_save_return_stop");
            var btnExit = document.querySelector("#formReturnStopFormTemplate #btn_exit_return_stop");

            btnExit.onclick = function () {
                that.modalForm.closeModalWindow();
            };

            btnSave.onclick = function () {
                that.doReturn();
            };

        } catch (e) {

            var error = new Monet.Exception.ReturnError(this, "No add event listenner to form.");
            error.console();

        }

    };

    this.doReturn = function () {

        var formDataJson = {};
        var that = this;
        var error = null;
        var formValues = this.getFormValues();
        var isValid = this.validateForm();
        var driverParameter = "/NoDriver";

        if (isValid) {

            formDataJson = {
                actualDeparture: formValues.date,
                undeliverableCode: {
                    id: formValues.returnCode
                }
            };

            if (this.routeId !== null) {
                if (this.stop !== null) {
                    this.modalForm.toggleLoadingInModalBtn();

                    if (formValues.driverId) {
                        driverParameter = "/Driver?id=" + formValues.driverId;
                    }

                    const ajax = new Monet.Ajax();

                    const stopKey = this.stop.get('stop').key;
                    const parsedStopKey = Greenmile.Stop.Util.formatStopKey(stopKey);

                    ajax.url = `Route/${this.routeId}/Stop/${parsedStopKey}/Return${driverParameter}`;
                    ajax.method = 'POST';
                    ajax.data = formDataJson;
                    ajax.success = (data) => {
                      if (successCallback) {
                        successCallback();
                      } else {
                        App.Forms.RouteSummaryStops.pagination.first = 0;
                        that.successCallback(data);
                      }

                      that.modalForm.closeModalWindow();
                    };
                    ajax.error = (data) => {
                        that.modalForm.toggleLoadingInModalBtn();
                        that.errorCallback(data);
                    };
                    ajax.send();

                } else {

                    error = new Monet.Exception.ReturnError(this,
                        "stop can't be null");
                    error.console();

                }
            } else {

                error = new Monet.Exception.ReturnError(this,
                    "routeId can't be null");
                error.console();

            }
        }

    };

    this.getFormValues = function () {

        var returnCodeElement = document.querySelector("#formReturnStopFormTemplate #returnCodes");
        var arriveTimeField = document.querySelector("#formReturnStopFormTemplate .dateTimePicker");
        var driver = document.getElementById("driversList");

        var isValid = this.validateForm();
        var error = null;

        if (isValid) {

            const formattedDate = Monet.Format.DateTime.parseLocaleToISOString(arriveTimeField.value);

            var objReturn = {
                date: formattedDate,
                returnCode: returnCodeElement.value

            };

            if (driver) {
                objReturn.driverId = driver.value;
            }

            return objReturn;

        } else {
            error = new Monet.Exception.ReturnError(this,
                "Form data is invalid");
            error.console();
        }

        return false;

    };

    this.validateForm = function () {

        let error = null;
        let isValid = true;
        const undeliverableTime = document.getElementById("returnTime");
        const routeActualStart = this.stop.get('route').actualStart;
        const stopActualArrival = this.stop.get('stop').actualArrival;
        const utils = new Greenmile.Route.ModalUtils();
        const scopeMessage = '#formReturnStopFormTemplate';
        const undeliverableTimeTimeMili = Monet.Format.DateTime.parseLocale(undeliverableTime.value).getTime();
        const stopActualArrivalMili = Monet.Format.DateTime.parse(stopActualArrival).getTime();
        const routeStartTimeMili = Monet.Format.DateTime.parse(routeActualStart).getTime();

        try {

            if (undeliverableTime.value.trim() === "") {

                utils.showErrorMessage(
                    scopeMessage,
                    "arrive_date",
                    "Stop.Return.cantDepartWithoutDateTime"
                );

                isValid = false;

            } else {

                if (undeliverableTimeTimeMili <= stopActualArrivalMili || undeliverableTimeTimeMili <= routeStartTimeMili) {

                    utils.showErrorMessage(
                        scopeMessage,
                        "date_before_route_and_stop",
                        "Stop.Return.cantReturnBeforeGreaterArrive"
                    );

                    isValid = false;

                }

                if (undeliverableTimeTimeMili >= new Date().getTime()) {
                  utils.showErrorMessage(
                    scopeMessage,
                    'driver',
                    'Stop.Return.cantArriveInTheFuture'
                  );

                  isValid = false;
                }

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No validate form.");
            error.console();

            isValid = false;

        }

        return isValid;
    };

    this.createAllStructure = function (scope) {
        return function () {
            scope.prepareToCreateForm();
            scope.createForm();
            scope.loadData();
            scope.addEventListenners();
        };
    }(this);

    const init = function (scope) {

        return function (scope) {

            const selector = parentSelector;
            const scopeBlock = ".mainContainer";

            const options = {
                width: 280,
                height: 320
            };

            const callbacks = {
                onAfterShowModalForm: scope.createAllStructure
            };

            scope.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);

        }(scope);

    };

    init(this);

};
